export function getPathname(url: string) {
	return new URL(url).pathname;
}

export function isErrorStatusCode(status: number) {
	return status >= 400;
}

export function localStorageGetNumber(key: string, defaultValue: number) {
	const item = localStorage.getItem(key);
	if (item === null) {
		return defaultValue;
	}
	const num = parseInt(item);
	return isNaN(num) ? defaultValue : num;
}

export function localStorageGetBoolean(key: string, defaultValue: boolean) {
	const item = localStorage.getItem(key);
	if (item === null) {
		return defaultValue;
	}
	return item === "true" ? true : item === "false" ? false : defaultValue;
}

export function buildAnchorUrl(url: string, anchor: string): string {
	return url + "#:~:text=" + encodeURIComponent(anchor);
}
